import React from 'react';
import { Button, Card, Stack, Center, Text, Title } from "@mantine/core";

interface AdminEmptyStateProps {
  /** Icon to display */
  icon: string;
  /** Title for empty state */
  title: string;
  /** Description text */
  description: string;
  /** Optional action button */
  actionButton?: {
    text: string;
    onClick: () => void;
    color?: string;
    icon?: string;
  };
  /** Optional illustration or additional content */
  illustration?: React.ReactNode;
}

/**
 * Standardized empty state component for admin pages
 * Provides consistent messaging and call-to-action patterns
 */
const AdminEmptyState: React.FunctionComponent<AdminEmptyStateProps> = ({
  icon,
  title,
  description,
  actionButton,
  illustration
}) => {
  return (
    <Card 
      shadow="sm" 
      padding="xl" 
      radius="md" 
      style={{ backgroundColor: 'var(--color-admin-elevated)' }}
    >
      <Center>
        <Stack align="center" gap="lg" style={{ maxWidth: '400px' }}>
          {illustration || (
            <i 
              className={icon} 
              style={{ 
                fontSize: '64px', 
                opacity: 0.5,
                color: 'var(--color-text-disabled)' 
              }} 
            />
          )}
          
          <Title 
            order={4} 
            ta="center"
            c="dimmed"
          >
            {title}
          </Title>
          
          <Text 
            size="sm" 
            ta="center" 
            c="dimmed"
          >
            {description}
          </Text>
          
          {actionButton && (
            <Button 
              color={actionButton.color || 'blue'}
              variant="filled"
              size="lg"
              onClick={actionButton.onClick}
              leftSection={actionButton.icon && (
                <i className={actionButton.icon} />
              )}
            >
              {actionButton.text}
            </Button>
          )}
        </Stack>
      </Center>
    </Card>
  );
};

export default AdminEmptyState;
